var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanningTimeCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 2.51874H13.75V1.26874H12.5V2.51874H7.5V1.26874H6.25V2.51874H3.75C3.05964 2.51874 2.5 3.07838 2.5 3.76874V16.2687C2.5 16.9591 3.05964 17.5187 3.75 17.5187H16.25C16.9404 17.5187 17.5 16.9591 17.5 16.2687V3.76874C17.5 3.07838 16.9404 2.51874 16.25 2.51874ZM16.25 16.2687H3.75V7.51874H16.25V16.2687ZM16.25 6.26874H3.75V3.76874H6.25V5.01874H7.5V3.76874H12.5V5.01874H13.75V3.76874H16.25V6.26874Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningTimeCalendarIcon);
export default __webpack_public_path__ + "static/media/planning-time-calendar-icon.93d9ebdf2ae0eabbae948734894bca8b.svg";
export { ForwardRef as ReactComponent };